"use client";
import { createContext } from "../../utils/create-context.js";
//#region src/components/checkbox/use-checkbox-group-context.tsx
var [CheckboxGroupContextProvider, useCheckboxGroupContext] = createContext({
	name: "CheckboxGroupContext",
	hookName: "useCheckboxGroupContext",
	providerName: "<CheckboxGroupProvider />",
	strict: false
});
//#endregion
export { CheckboxGroupContextProvider, useCheckboxGroupContext };
